import { render, staticRenderFns } from "./BenefitsSection.vue?vue&type=template&id=b231171a&"
import script from "./BenefitsSection.vue?vue&type=script&lang=js&"
export * from "./BenefitsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports